export default "__VITE_ASSET__8cf630d1__"